import React from "react";
import { StyledCol, StyledTableRow } from "../../../styles/styledTable";
import { TimestampToDateMoment } from "../../../../utils/timestampToDate";
import RenderStatus from "../../../styles/styledStatus";

const TelegramConnectionsItem = ({ conn, onEdit, onDelete, t }) => (
  <StyledTableRow scroll="auto" col="8">
    <StyledCol data-title={t("connections.table.project")}>
      {conn.projectName || "--"}
    </StyledCol>
    <StyledCol data-title={t("connections.table.type")}>
      {conn.type}
    </StyledCol>
    <StyledCol data-title={t("connections.table.connection")}>
      <span style={{ paddingBottom: "4px" }}>{conn.connectionName}</span>
      {conn.connectionId}
    </StyledCol>
    <StyledCol data-title={t("connections.table.service")}>
      {conn.serviceName}
    </StyledCol>
    <StyledCol inline data-title={t("connections.table.pairs")}>
      <span>
        {(conn.pairs || []).length === 0 && "--"}
        {(conn.pairs || []).map((p, i) => (
          <div
            key={i}
            style={{ marginRight: 2, marginBottom: 2 }}
          >
            {p.currencyId}{p.paymentSystemId !== p.currencyId && ` (${p.paymentSystemId})`}
          </div>
        ))}
      </span>
    </StyledCol>
    <StyledCol inline data-title={t("connections.table.status")}>
      <RenderStatus status={conn.isActive ? "ACTIVE" : "INACTIVE"} />
    </StyledCol>
    <StyledCol data-title={t("connections.table.createdAt")}>
      {TimestampToDateMoment(conn.createdAt)}
    </StyledCol>
    <StyledCol data-title={t("connections.table.actions")}>
      <button className="table-action table-action_info" onClick={() => onEdit(conn)}>
        <span className="icon-light-edit" />
        {t("common.edit")}
      </button>
      <button className="table-action table-action_danger" onClick={() => onDelete(conn.id)}>
        <span className="icon-light-trash" />
        {t("common.delete")}
      </button>
    </StyledCol>
  </StyledTableRow>
);

export default TelegramConnectionsItem;